import React, {useEffect, useState} from "react";
import MainLayout from "../MainLoyout/MainLayout";
import {Box, Container, Drawer, FormControl, InputLabel, Paper, Select} from "@mui/material";

import Title from "../Title";
import Success from "../Snackbar/Success";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import countryList from "react-select-country-list";
import Button from "@mui/material/Button";
import Api from "../../Services/Api";


const PaymentMethodForm = ({form, setForm, setDrawer, setReload}) => {

    const [countries, setCountries] = React.useState([]);



    useEffect(() => {

        setCountries(countryList().getData())


    }, []);

    const handleSubmit = async (event) => {

        event.preventDefault();
        Api.storePaymentMethod(form).then( r => { setDrawer(false); setReload("payment")})


    }

    const handleChange = (event) => {


        setForm(prevState =>
            ({
                ...prevState,
                [event.target.name]: event.target.value
            })
        )
    };



    return (

                        <Box component={"form"} onSubmit={handleSubmit}  sx={{ width: 350, p: 2 }}>
                            <Title>{!form?.id ? "New Payment Method":"Payment method"}</Title>
                            <TextField label="Bank Name" disabled={form?.id}  value={form?.bank_name} required={true} name={"bank_name"} variant="outlined" onChange={handleChange} fullWidth margin="normal"/>
                            <FormControl variant="outlined" fullWidth={true} sx={{mt: 2}} required={true}>
                                <InputLabel id="country">Bank Country</InputLabel>
                                <Select
                                    labelId="country"
                                    id="country"
                                    name={"country"}
                                    required={true}
                                    disabled={form?.id}
                                    value={form?.country ?? ''}
                                    label="Country"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {countries?.map((item,key) => <MenuItem key={key} value={item.value}>{item.label}</MenuItem>)}

                                </Select>
                            </FormControl>
                            <TextField label="Address" disabled={form?.id}  value={form?.address} required={true} name={"address"} variant="outlined"  onChange={handleChange} fullWidth margin="normal"/>
                            <TextField label="City"    disabled={form?.id} value={form?.city} name={"city"}  required={true} onChange={handleChange} variant="outlined" fullWidth margin="normal"/>
                            <TextField label="Account Number"  disabled={form?.id}  value={form?.account_number} required={true} onChange={handleChange} name={"account_number"} variant="outlined" fullWidth margin="normal"/>
                            <TextField label="IBAN"  disabled={form?.id}  required={false} value={form?.iban} onChange={handleChange} name={"iban"} variant="outlined" fullWidth margin="normal"/>
                            <TextField label="SWIFT" required={true} disabled={form?.id}   value={form?.swift} onChange={handleChange} name={"swift"} variant="outlined" fullWidth margin="normal"/>
                            <FormControl variant="outlined"  disabled={form?.id}  fullWidth sx={{mt: 2}} required={true}>
                                <InputLabel id="currency">Currency</InputLabel>
                                <Select
                                    labelId="currency"
                                    id="currency"
                                    name={"currency"}
                                    required={true}
                                    disabled={form?.id}
                                    value={form?.currency ?? ''}
                                    label="Currency"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    <MenuItem value="eur">
                                        <em>EUR</em>
                                    </MenuItem>
                                    <MenuItem value="usd">
                                        <em>USD</em>
                                    </MenuItem>

                                </Select>
                            </FormControl>
                            <TextField label="Notes"  disabled={form?.id} value={form?.notes} required={false} onChange={handleChange} name={"notes"} variant="outlined" fullWidth margin="normal"/>

                            {!form?.id && <Button variant={'contained'} type={"submit"} fullWidth >Create Payment Method</Button>}
                        </Box>

    )
}


export default PaymentMethodForm